"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function MicrosoftCalenderMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__microsoft-calender-multitone-filled__clip0_22973_2663)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2279D1",
    d: "M.03 15.347v.063c.217.231.4.5.782.498 1.434-.011 2.868-.012 4.303-.017.042-.345-.07-.681-.059-1.024.03-.986-.044-1.972.049-2.959.028-.3.106-.381.404-.38 1.798.011 3.596.005 5.395.004 0-1.33.01-2.659-.004-3.988-.002-.303.105-.392.405-.39 1.532.01 3.063.004 4.595.004l.01-4.378-5.011.008c.003 1.33-.003 2.662.015 3.992.004.302-.087.388-.392.386-1.819-.012-3.638-.004-5.457-.003l-.004.003c0 1.34-.01 2.682.003 4.022.002.276-.083.355-.361.353-1.533-.012-3.066-.007-4.599-.007l-.008.011.001 3.544c0 .09.024.19-.065.258H.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ED9FD",
    d: "M.03 2.78v8.754l.065.011.008-.01c-.002-1.365 0-2.729-.01-4.093-.003-.22.078-.287.296-.285 1.557.008 3.114.007 4.671.01l.004-.004-.018-4.366c-.19-.003-.38-.01-.571-.01l-4.38-.011c-.02.002-.043.003-.064.006V2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFD",
    d: "M5.115 15.892c-1.435.005-2.869.006-4.303.017-.382.002-.565-.268-.781-.499 0 .188-.075.449.021.542.096.094.361.021.551.021 5.045 0 10.09-.002 15.136.006.217 0 .261-.042.26-.256-.008-5.127-.01-10.254.001-15.38 0-.265-.055-.361-.326-.316-.124.02-.253.003-.38.003a.463.463 0 00-.021.047c.423.102.638.326.643.722.008.66-.004 1.32-.007 1.982l-.01 4.378c.03 1.46.03 2.917 0 4.376.006 1.217.022 2.433.012 3.65-.003.421-.304.713-.728.716-1.407.01-2.814 0-4.221-.003l-.027.005-.027-.009-5.793-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ED9FD",
    d: "M15.272.077l.02-.047H.73c0 .017.006.03.018.042.104.007.21.019.315.019h13.925c.095 0 .19-.01.285-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA7E7",
    d: "M.095 11.545c-.022-.004-.043-.007-.064-.012v3.814c.09-.07.065-.168.065-.258l-.001-3.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFD",
    d: "M.748.072A.055.055 0 01.73.03H.666C.455.03.16-.05.054.053-.052.157.03.447.03.655.048.643.064.645.08.658.147.29.383.112.747.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA7E7",
    d: "M.08.658C.065.643.048.642.03.655v2.126l.066-.006L.08.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B64B5",
    d: "M.08.658l.016 2.117 4.379.011c.19 0 .38.007.57.01l5.853-.008 5.01-.008c.004-.66.016-1.321.008-1.982-.005-.395-.22-.62-.643-.72-.096.004-.19.013-.285.013H1.063C.958.09.853.079.748.072c-.363.04-.6.22-.668.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA7E7",
    d: "M10.897 2.788l-5.852.008.018 4.367c1.82-.001 3.638-.009 5.457.003.305.002.397-.084.393-.386-.018-1.33-.013-2.661-.016-3.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B64B5",
    d: "M5.115 15.892l5.792.002a.25.25 0 010-.05l.01-4.3-.013-.012c-1.798 0-3.597.008-5.395-.004-.298-.001-.377.08-.404.38-.092.987-.02 1.974-.049 2.959-.01.343.1.68.059 1.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B64B5",
    d: "M15.9 11.535c.027-1.459.028-2.917 0-4.376-1.532 0-3.064.006-4.596-.005-.3-.002-.407.088-.404.39.012 1.33.004 2.659.003 3.989l.012.011 4.984-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA7E7",
    d: "M5.06 7.166c-1.557-.003-3.113-.002-4.67-.01-.218 0-.3.065-.298.285.01 1.364.009 2.728.011 4.092 1.533 0 3.066-.005 4.599.007.278.003.363-.077.36-.353-.011-1.34-.002-2.68-.002-4.022v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154A8A",
    d: "M15.9 11.535l-4.984.01-.01 4.3c.02.017.037.035.056.053 1.407.002 2.814.012 4.221.003.424-.003.725-.295.728-.716.01-1.216-.006-2.433-.012-3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2279D1",
    d: "M10.962 15.898l-.055-.053v.05l.026.01.027-.007h.002z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__microsoft-calender-multitone-filled__clip0_22973_2663"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z",
    transform: "matrix(-1 0 0 1 16 0)"
  }))));
}

MicrosoftCalenderMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
MicrosoftCalenderMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = MicrosoftCalenderMultitoneFilled;
exports["default"] = _default;